import React from 'react';
import Text from './Text';
import { range } from '../util';
import { TOKEN_INFO, RollValue } from '../game-info';

interface TokenProps {
  size: number;
  x?: number;
  y?: number;
  value: RollValue;
}

export default function Token({
  size,
  x = 0,
  y = 0,
  value,
}: TokenProps) {
  if (value === 7) {
    return null;
  }
  const likelihood = TOKEN_INFO[value].likelihood;
  const dotSpacing = size / 8;
  const dotOffset = (dotSpacing * (likelihood - 1)) / 2;
  const color = likelihood > 4
    ? '#c00'
    : '#000';
  return (
    <g x={x} y={y}>
      <circle
        cx="0"
        cy="0"
        r={size / 2}
        fill="#fff"
        stroke="rgba(0,0,0,0.3)"
        strokeWidth={size / 30}
      />
      <Text
        y={-size * 0.1}
        align="center"
        size={size / 2}
        weight="700"
        color={color}
        text={value + ''}
      />
      { range(likelihood).map(idx => {
        return (
          <circle
            key={idx}
            r={dotSpacing / 3}
            fill={color}
            cx={(x + idx * dotSpacing) - dotOffset}
            cy={y + size / 4.5}
          />
        );
      }) }
    </g>
  );
}
